import "../firebase/config.js";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

export const LEAD_TYPES = {
  GET_IN_TOUCH: "get_in_touch",
  SINGLE_CAR_TESTDRIVE: "single_car_testdrive",
  SINGLE_CAR_PROPOSAL: "single_car_proposal",
  CAMPAIGN_TESTDRIVE: "campaign_testdrive",
  CAMPAIGN_OFFER: "campaign_offer",
};

export async function submitLeadEmail(payload) {
  const sendLeadEmail = httpsCallable(functions, "sendLeadEmail");
  const result = await sendLeadEmail(payload);
  return result.data;
}
